import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';

@Component({
  selector: 'app-verify-log-details',
  templateUrl: './verify-log-details.component.html',
  styleUrls: ['./verify-log-details.component.css']
})
export class VerifyLogDetailsComponent implements OnInit {
  showVerify = false;
  showPayment = false;
  showPrivateNote = false;
  title: string;
  verificationDetails: any = [];
  paymentDetails: any = [] ;
  privateNotes: any = [];
  privateNoteData: any = {};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private datepipe: DateFormatPipe) { }

  ngOnInit() {
    console.log('typer....' + this.data['type']);
    switch (this.data['type']) {
      case 'verify': {
        console.log('inisde verify');
        console.log('inisde verify' + this.data['value']);
       this.showVerify = true;
       this.title = 'VERIFICATION';
       const verificationlog = this.data['value'];
       this.verificationDetails = verificationlog.changeLog;
       console.log('verify' + JSON.stringify(this.verificationDetails));
       break;
      }
      case 'payment': {
        console.log('inisde payment');
        this.showPayment = true;
        this.title = 'PAYMENT';
        const paymentlog = this.data['value'];
        this.paymentDetails = paymentlog.changeLog;
        console.log('paymnet ' + JSON.stringify(this.paymentDetails));

        break;
      }
      case 'privateNote': {
        this.showPrivateNote = true;
        this.title = 'PRIVATE NOTE';
        const privateNotelog = this.data['value'];
        this.privateNotes = privateNotelog.privateNote;
        console.log('priavteNotes ' + JSON.stringify(this.privateNotes));
        break;
      }

    }

  }
  getCorrectDateAndTimeFormat(dateVal){
    return this.datepipe.simpledateFormatWithTime(dateVal);
  }
  getCorrectDate(dateval) {
    return this.datepipe.simpledateFormat(dateval);
  }


}
